import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import FeatureFlagsContext, {FeatureFlags} from 'contexts/FeatureFlagsContext';

export type WithFeatureFlagsProps = {
    featureFlags: FeatureFlags;
};

export default function withFeatureFlags<T extends WithFeatureFlagsProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithFeatureFlags extends React.Component<Omit<T, keyof WithFeatureFlagsProps>> {
        static displayName = `withFeatureFlags(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = FeatureFlagsContext;

        render() {
            return <WrappedComponent {...(this.props as T)} featureFlags={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithFeatureFlags, WrappedComponent);
    return WithFeatureFlags;
}
